import { render, staticRenderFns } from "./chartConsumo.vue?vue&type=template&id=3acf2fa5&"
import script from "./chartConsumo.vue?vue&type=script&lang=js&"
export * from "./chartConsumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports